import { useEffect } from 'react';

function CustomerStyles(selectedCustomer) {
  useEffect(() => {
    // Vérification que selectedCustomer existe
    if (!selectedCustomer || !selectedCustomer.name) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `/assets/styles/${selectedCustomer.name}.css`;
    document.head.appendChild(link);
    
    return () => {
      document.head.removeChild(link);
    };
  }, [selectedCustomer]);
}

export default CustomerStyles;
